export default __webpack_public_path__ + "static/media/leh2.0a8fd865.jpg";